export default class HeaderRules {
    rules = []

    constructor(fileRules){
        this.rules = fileRules
    }

    deductTypeFromHeader(header:string){
        for (const rule of this.rules) {
            for (const pattern of rule.patterns) {
                if (header.match(pattern)) {
                    return rule
                }
            }
        }
        return null
        // let deduction = this.rules.find(rule => rule.patterns.find(pattern => !!header.match(pattern)))
        // return deduction
    }
}
